import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import ApplyButton from './ApplyButton';
interface TeamMemberProps {
  name: string;
  title: string;
  bio: string;
  imageUrl: string;
  index: number;
}
const TeamMember = ({
  name,
  title,
  bio,
  imageUrl,
  index
}: TeamMemberProps) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 50
  }} animate={inView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 50
  }} transition={{
    duration: 0.7,
    delay: index * 0.2
  }} className="w-full md:w-[calc(33.333%-1rem)]" data-id="element-252">
      <div className="h-full bg-gradient-to-b from-gray-50 to-white border border-gray-200 rounded-lg overflow-hidden shadow-md flex flex-col p-5 sm:p-8" data-id="element-253">
        <div className="flex items-center mb-4 sm:mb-5" data-id="element-254">
          <div className="w-16 h-16 sm:w-20 sm:h-20 mr-4 sm:mr-5 rounded-full overflow-hidden ring-4 ring-[#ffdf07] ring-offset-2 ring-offset-white flex-shrink-0" data-id="element-255">
            <img src={imageUrl} alt={name} className="w-full h-full object-cover object-center" data-id="element-256" />
          </div>
          <div className="min-w-0" data-id="element-257">
            <h3 className="text-xl sm:text-2xl text-gray-900 mb-1 typekit-heading" data-id="element-258">
              {name}
            </h3>
            <p className="text-[#b8860b] text-sm sm:text-base font-medium leading-tight" data-id="element-259">
              {title}
            </p>
          </div>
        </div>
        <p className="text-gray-600 libre-caslon-text-regular leading-relaxed text-base sm:text-lg" data-id="element-260">
          {bio}
        </p>
      </div>
    </motion.div>;
};
interface TeamSectionProps {
  scrollToCalendar?: () => void;
}
const TeamSection = ({
  scrollToCalendar
}: TeamSectionProps) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const team = [{
    name: 'Andra Grija, MBA',
    title: 'Head of Provider Success',
    bio: 'Led finance for clinic expansions at Esperanza Health Centers. Knows the day-to-day realities of running a practice.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyVG1jyaW9YHXNQHLxmwxz/pasted-image.jpg'
  }, {
    name: 'Elena Ivanov',
    title: 'Transaction & Valuation Lead',
    bio: 'EY-Parthenon alum. Shows you how buyers will evaluate your clinic – so you can fix issues before they cost you.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3k5yM8Z1hHgh5YjPipTp5m/pasted-image.jpg'
  }, {
    name: 'Ivan Acuna',
    title: 'Founder & Capital Strategy',
    bio: 'Works directly with buyers and investors. Translates what capital wants into steps you can take today.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mRAuUG8YWv2RMwmk41SxrT/pasted-image.jpg'
  }];
  return <section className="w-full bg-white py-12 sm:py-20 px-3 sm:px-4" data-id="element-261">
      <div className="max-w-6xl mx-auto" data-id="element-262">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.7
      }} className="text-center mb-8 sm:mb-14" data-id="element-263">
          <h2 className="text-gray-900 text-2xl sm:text-3xl md:text-4xl mb-4 sm:mb-6 typekit-heading" data-id="element-264">
            Who's Behind the Numbers
          </h2>
          <p className="text-gray-600 libre-caslon-text-regular leading-relaxed max-w-3xl mx-auto text-base sm:text-lg px-1" data-id="element-265">
            Not generic consultants. A team that's worked inside clinics and
            closed healthcare deals.
          </p>
        </motion.div>
        <div className="flex flex-col md:flex-row justify-between gap-4 sm:gap-6" data-id="element-266">
          {team.map((member, index) => <TeamMember key={index} name={member.name} title={member.title} bio={member.bio} imageUrl={member.imageUrl} index={index} data-id="element-267" />)}
        </div>
        <div className="mt-8 sm:mt-12" data-id="element-268">
          {scrollToCalendar ? <div className="flex justify-center" data-id="element-269">
              <div className="relative" data-id="element-270">
                <div className="button-border-light" data-id="element-271"></div>
                <motion.button onClick={scrollToCalendar} whileHover={{
              scale: 1.05,
              boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
            }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-2.5 sm:py-3 px-6 sm:px-10 rounded-md text-sm sm:text-base shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-272">
                  Book My Strategy Call
                </motion.button>
              </div>
            </div> : <ApplyButton data-id="element-273" />}
        </div>
      </div>
    </section>;
};
export default TeamSection;